import { Grid, useMediaQuery, useTheme } from "@mui/material";
import DsasButton from "../../../../../components/DsasButton/DsasButton.js";

const SelectTeam = ({ keyValue, event, directEvent,  onChange, custo }) => {

  // Regrouper tous les boutons dans un seul tableau
  const allOptions = [
    directEvent.homeTeam,
    directEvent.awayTeam,
    ...(custo || [])
  ];

  return (
    <div className="select-team centered-wrapper">
      <Grid
        container
        spacing={1}
        justifyContent="center"
        alignItems="center"
        className="team-options centered-wrapper medium-padding"
      >
        {allOptions.map((opt) => (
          <Grid item xs={12} sm={12} lg={6} key={opt._id}>
            <DsasButton
              label={opt.name || opt.label}
              variant="alternative"
              focused={event[keyValue] === opt._id}
              onClick={() => onChange(keyValue, opt._id)}
              customCss={{width:'100%'}}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default SelectTeam;
